export default __webpack_public_path__ + "static/media/ホテルについて.b92af8cd.pdf";